module.exports = __webpack_public_path__ + "img/ikone-background.11a9888d.png";